/** Returns a human-readable reason why a filter failed evaluation */
export function getFilterFailureReason(filterKind: string): string {
  if (filterKind === 'DontMatchOnConditions') {
    return 'No matching conditions';
  }
  if (filterKind === 'NoMatchingAgent') {
    return 'No agent assigned';
  }
  // Invalid, or other unexpected cases
  return 'Configuration error';
}

/** Returns the appropriate status text for a channel delivery option */
export function getChannelStatusText(
  channelKind: string,
  channelIsEligible: boolean,
  filterIsFullyEligible: boolean,
): string {
  // Channel is technically eligible
  if (channelIsEligible) {
    if (filterIsFullyEligible) {
      // Filter passed completely but this channel wasn't chosen (another had higher priority)
      return 'matched but not selected';
    }
    // Filter matched some conditions but failed others (e.g., language check failed)
    return '(incomplete path)';
  }

  // Channel has specific issues
  if (channelKind === 'EndUserDoesNotHaveContactPointOfKindNeededByChannel') {
    return '(customer missing contact point)';
  }

  if (channelKind === 'SurveyDoesNotExist') {
    return '(survey not found)';
  }

  // Fallback for unexpected cases
  return '';
}
